<template>
  <v-autocomplete
    label="Misinformation Susceptibility"
    :placeholder="misinfoSusceptibilityPlaceholder"
    v-model="misinfoSusceptibility"
    :items="autocompleteOptions"
    item-text="name"
    item-value="code"
    clearable
    hide-details
    multiple
    class="mb-4 hyp-source-metadata-exclude-placeholder"
    @change="handleOnChange"
  >
    <template v-slot:selection="{ index }">
      <span v-if="index === 0">
        {{ misinfoSusceptibility.length }} selected
      </span>
    </template>
    <template v-slot:prepend-item>
      <!--      vvvvvvvvvvvvvvvvv Exclude Misinformation Susceptibility Tagged Toggle vvvvvvvvvvvvvvvvvvvv-->
      <!--      Removed for AAAS-8288. Keeping logic for now just in case ;) -->
      <!--      <v-list-item-->
      <!--        ripple-->
      <!--        class="cursor-pointer"-->
      <!--        @mousedown.prevent-->
      <!--        @click="handleExcludeMisinfoSusceptibility"-->
      <!--      >-->
      <!--        <v-list-item-action>-->
      <!--          <v-icon-->
      <!--            class="mr-n3"-->
      <!--            large-->
      <!--            :color="excludeMisinfoSusceptibilityTagged ? 'primary' : ''"-->
      <!--          >-->
      <!--            {{ excludeIcon }}-->
      <!--          </v-icon>-->
      <!--        </v-list-item-action>-->
      <!--        <v-list-item-content>-->
      <!--          <v-list-item-title>-->
      <!--            Exclude misinformation susceptibility tagged sources-->
      <!--          </v-list-item-title>-->
      <!--        </v-list-item-content>-->
      <!--      </v-list-item>-->
      <!--      <v-divider class="mt-2"></v-divider>-->
      <!--      <v-divider></v-divider>-->
      <!--      <v-divider></v-divider>-->
      <!--       ^^^^^^^^^^^^^ Exclude Misinformation Susceptibility Tagged Toggle ^^^^^^^^^^^^^-->
      <v-list-item ripple @mousedown.prevent @click="selectAllItems">
        <v-list-item-action>
          <v-icon :color="misinfoSusceptibility.length > 0 ? 'primary' : ''">
            {{ itemsAllIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Select All
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { getCountryList } from "@/common/maps/utilities";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "SearchFilterMisinfoSusceptibility",
  props: {
    selected: {
      type: Array,
    },
    counts: {
      type: Object,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      issueSpecificItem: {
        name: "Issue Specific",
        code: "issueSpecific",
        originalName: "Issue Specific",
      },
      misinfoSusceptibility: [],
      excludeMisinfoSusceptibilityTagged: false,
      items: [],
    };
  },
  computed: {
    autocompleteOptions() {
      const getDisplayName = (code, name) =>
        this.counts?.[code] != null && !Number.isNaN(this.counts[code])
          ? `${name} (${this.counts[code]})`
          : name;

      return this.items.map(({ code, name, ...rest }) => ({
        ...rest,
        code: code,
        name: getDisplayName(code, name),
      }));
    },
    misinfoSusceptibilityPlaceholder() {
      return this.excludeMisinfoSusceptibilityTagged
        ? "Exclude tagged sources"
        : null;
    },
    excludeIcon() {
      return this.excludeMisinfoSusceptibilityTagged
        ? "mdi-toggle-switch"
        : "mdi-toggle-switch-off";
    },
    itemsSelectedAll() {
      return this.misinfoSusceptibility.length === this.items.length;
    },
    itemsSelectedSome() {
      return this.misinfoSusceptibility.length > 0 && !this.itemsSelectedAll;
    },
    itemsAllIcon() {
      if (this.itemsSelectedAll) {
        return "mdi-close-box";
      }
      if (this.itemsSelectedSome) {
        return "mdi-minus-box";
      }
      return "mdi-checkbox-blank-outline";
    },
  },
  async mounted() {
    await this.setupItems();
  },
  methods: {
    async setupItems() {
      const countries = await getCountryList();
      this.items = [this.issueSpecificItem].concat(countries);
    },
    handleOnChange() {
      this.excludeMisinfoSusceptibilityTagged =
        this.misinfoSusceptibility.length > 0
          ? false
          : this.excludeMisinfoSusceptibilityTagged;
      this.emitChanges();
    },
    handleExcludeMisinfoSusceptibility() {
      this.excludeMisinfoSusceptibilityTagged = !this
        .excludeMisinfoSusceptibilityTagged;
      this.misinfoSusceptibility = this.excludeMisinfoSusceptibilityTagged
        ? []
        : this.misinfoSusceptibility;
      this.emitChanges();
    },
    emitChanges() {
      this.$emit(EMITTED_ACTIONS.CHANGE, [
        {
          type: "misinfoSusceptibility",
          value: this.excludeMisinfoSusceptibilityTagged
            ? ["excludeMisinfoSusceptibilityTagged"]
            : this.misinfoSusceptibility,
        },
      ]);
    },
    selectAllItems() {
      this.$nextTick(() => {
        if (this.misinfoSusceptibility.length === this.items.length) {
          this.misinfoSusceptibility = [];
        } else {
          this.misinfoSusceptibility = this.items.map((x) => x.code);
        }
        this.handleOnChange();
      });
    },
  },
  watch: {
    selected: {
      handler() {
        this.misinfoSusceptibility = this.selected.filter((selection) => {
          return selection !== "excludeMisinfoSusceptibilityTagged";
        });
        this.excludeMisinfoSusceptibilityTagged = this.selected.includes(
          "excludeMisinfoSusceptibilityTagged"
        )
          ? true
          : false;
      },
      deep: true,
      immediate: true,
    },
    reset: {
      handler() {
        this.misinfoSusceptibility = [];
      },
    },
  },
};
</script>

<style lang="scss">
.hyp-source-metadata-exclude-placeholder.v-text-field input::placeholder {
  color: $primary-color;
  font-size: 12px;
}
</style>
